<template>
  <div>
    <!--
    <pre>
      {{active_task}}
    </pre>
    -->
    <annotation
      :active-annotations="active_annotations"
      :annotations="annotations"
      :on-change="onChange"
      :on-click="e => $emit('todo-select', e)"
      :on-submit="onSubmit"
      :disable-overlay="true"
      :src="active.asset.png"
      :render-editor="renderEditor"
      :render-content="renderNothing"
      :value="annotation"
      type="RECTANGLE"
      @dblclick.native="onCanvasClick"
    />
    <!--
      :renderEditor="renderNothing"
      :renderContent="renderNothing"
    -->
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { ReactInVue } from 'vuera';
import Annotation from 'react-image-annotation';
import { CREATE_NEW_TASK } from '@/config/constants';
import get_id from '@/utils/id';
import uuid from 'uuid';

export default {
  components: {
    annotation: ReactInVue(Annotation)
  },
  data() {
    return {
      active_annotations: [],
      annotations: [],
      annotation: {}
    };
  },
  watch: {
    active_task(val) {
      if (val) {
        const { data, geometry } = this.active_task;
        this.active_annotations = [data.id];
      }
    },
    tasks: {
      handler(val) {
        if (val) {
          this.annotations = _.map(
            _.filter(val, x => !!x),
            task => {
              let { data, geometry } = task;
              //
              if (!geometry) {
                geometry = {};
              }
              if (!geometry.type) {
                geometry.type = 'POINT';
              }
              //
              return { data, geometry };
            }
          );
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState('user', {
      email: state => state.me.email
    }),
    ...mapState('slides', {
      active: state => state.active
    }),
    ...mapState('tasks', {
      tasks: state => state.items,
      active_task: state => state.active
    })
  },
  methods: {
    renderEditor(props) {
      let data = props.annotation.data;
      props.annotation.data = {
        ...data,
        id: get_id(),
        text: '',
        author: this.email
      };
      props.annotation.comments = [];
      props.onSubmit();
    },
    renderNothing() {},
    onClick() {},
    onChange() {},
    async onCanvasClick(e) {
      let rect = e.target.getBoundingClientRect(),
        click_x = e.clientX - rect.left,
        click_y = e.clientY - rect.top,
        el_width = rect.width,
        el_height = rect.height,
        x = (click_x / el_width) * 100,
        y = (click_y / el_height) * 100,
        height = 1,
        width = 1,
        data = {
          text: 'Leerer Text',
          author: this.email
        };
      /*
        geometry: Object
          height: 7.153075822603718
          type: "RECTANGLE"
          width: 9.549356223175977
          x: 67.7038626609442
          y: 24.74964234620887
        */
      let task_id = uuid.v4();
      let annotation = {
        geometry: {
          x,
          y,
          height,
          width,
          type: 'POINT'
        },
        data: {
          ...data,
          id: task_id,
          text: '',
          author: this.email,
          comments: []
        },
        //status: STATI.BACKLOG,
        needTextUpdate: true
      };
      this.annotations = this.annotations.concat(annotation);
      await this.$store.dispatch(CREATE_NEW_TASK, annotation).then(() => {
        this.focusTask(task_id);
      });
    },
    onChange(annotation) {
      this.annotation = annotation;
    },
    onClick() {},
    async onSubmit(annotation) {
      let task_id = get_id();
      annotation.data.id = task_id;
      this.annotations = this.annotations.concat(annotation);
      this.annotation = {};
      let task = {};
      await this.$store.dispatch(CREATE_NEW_TASK, annotation).then(() => {
        this.focusTask(task_id);
      });
    },
    focusTask(task_id) {
      setTimeout(() => {
        var el = document.getElementById(`editor-${task_id}`);
        if (el) {
          var text = el.querySelector('.task-list-tile-text');
          if (text) {
            text.focus();
          }
        }
      }, 350);
    }
  }
};
</script>
